import React, { memo } from "react";
import { Box, Typography, Chip, Avatar } from "@mui/material";
import EngineeringIcon from "@mui/icons-material/Engineering";
import { C } from "../theme";
import { STATUS_LABELS, TECHNICIAN_STATUS } from "../constants";

const STATUS_COLOR = {
  [TECHNICIAN_STATUS.ACTIVE]: { bg: "#dcfce7", color: "#16a34a" },
  [TECHNICIAN_STATUS.INACTIVE]: { bg: "#fee2e2", color: "#dc2626" },
  [TECHNICIAN_STATUS.ON_LEAVE]: { bg: "#fef3c7", color: "#d97706" },
};

function getScore(tech) {
  const a = tech.attitudeScore ?? 0;
  const b = tech.adminComplianceScore ?? 0;
  if (!a && !b) return null;
  return Math.round((a + b) / 2);
}

const TechnicianSidebarItem = memo(function TechnicianSidebarItem({
  technician,
  selected,
  onClick,
}) {
  const score = getScore(technician);
  const statusStyle =
    STATUS_COLOR[technician.status] || STATUS_COLOR[TECHNICIAN_STATUS.ACTIVE];

  return (
    <Box
      onClick={onClick}
      sx={{
        px: 1.25,
        py: 1,
        borderRadius: 1.5,
        cursor: "pointer",
        border: `1px solid ${selected ? C.primary : "transparent"}`,
        bgcolor: selected ? C.primarySoft : "#fff",
        transition: "all .15s",
        "&:hover": { bgcolor: selected ? C.primarySoft : "#f9fafb" },
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Avatar
          sx={{
            width: 32,
            height: 32,
            bgcolor: selected ? C.primary : "#e5e7eb",
            color: selected ? "#fff" : C.textSoft,
            fontSize: 13,
            fontWeight: 700,
          }}
        >
          {technician.name?.charAt(0)?.toUpperCase() || (
            <EngineeringIcon sx={{ fontSize: 16 }} />
          )}
        </Avatar>

        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography noWrap sx={{ fontWeight: 700, fontSize: 13, color: C.text, lineHeight: 1.2 }}>
            {technician.name}
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.25 }}>
            <Chip
              size="small"
              label={STATUS_LABELS[technician.status] || technician.status}
              sx={{
                height: 18,
                fontSize: 9,
                fontWeight: 700,
                bgcolor: statusStyle.bg,
                color: statusStyle.color,
              }}
            />
            <Typography noWrap sx={{ fontSize: 10, color: C.textSoft }}>
              {technician.zone || technician.phone || ""}
            </Typography>
          </Box>
        </Box>

        {score !== null && (
          <Box
            sx={{
              minWidth: 28,
              height: 28,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 10,
              fontWeight: 700,
              flexShrink: 0,
              bgcolor:
                score >= 80 ? "#dcfce7" : score >= 60 ? "#fef3c7" : "#fee2e2",
              color:
                score >= 80 ? C.success : score >= 60 ? C.warning : C.danger,
            }}
          >
            {score}
          </Box>
        )}
      </Box>
    </Box>
  );
});

export default TechnicianSidebarItem;
